<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50 md-small-size-100">
      <ValidationProvider
        name="Start date"
        :rules="readonly ? '' : 'required'"
        v-slot="{ errors }"
      >
        <md-datepicker
          v-if="!readonly"
          v-model="startDate"
          md-immediately
          :md-model-type="String"
          :class="{ 'md-invalid': errors.length }"
        >
          <label>Start date</label>
          <span class="md-error">{{ errors[0] }}</span>
        </md-datepicker>
        <md-field v-else>
          <label>Start date</label>
          <md-input :value="startDate" readonly />
        </md-field>
      </ValidationProvider>
    </div>
    <div class="md-layout-item md-size-50 md-small-size-100">
      <ValidationProvider
        name="Number of days"
        :rules="readonly ? '' : 'required|integer|min_value:1'"
        v-slot="{ errors }"
      >
        <md-field :class="{ 'md-invalid': errors.length }">
          <label>Number of days</label>
          <md-input
            v-model="numberDays"
            type="number"
            min="1"
            step="1"
            :readonly="readonly"
            @input="emitDates(startDate)"
          />
          <span class="md-error">{{ errors[0] }}</span>
        </md-field>
      </ValidationProvider>
    </div>
    <div class="md-layout-item md-size-100">
      <ValidationProvider
        name="End date"
        :rules="readonly ? '' : 'required'"
        v-slot="{ errors }"
      >
        <md-field :class="{ 'md-invalid': errors.length }">
          <label>End date (calculated)</label>
          <md-input :value="value.end_date" readonly />
          <span class="md-error">{{ errors[0] }}</span>
        </md-field>
      </ValidationProvider>
      <p class="md-caption">Number of days includes the start and end dates.</p>
    </div>
  </div>
</template>

<script>
import { extend } from "vee-validate";
import { required, integer, min_value } from "vee-validate/dist/rules";
import { departureDays, departureEndDate } from "@/helpers/departureDates";

extend("required", required);
extend("integer", integer);
extend("min_value", min_value);

export default {
  props: {
    value: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
    initialDays: { type: Number, default: null }
  },
  data() {
    return { numberDays: null, emittedDates: null };
  },
  computed: {
    startDate: {
      get() {
        return this.value.start_date;
      },
      set(value) {
        this.emitDates(value);
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        // Keep incomplete day-count input while the parent accepts our date update.
        if (
          this.emittedDates &&
          value.start_date === this.emittedDates.start_date &&
          value.end_date === this.emittedDates.end_date
        )
          return;
        this.numberDays =
          !value.start_date && !value.end_date
            ? this.initialDays
            : departureDays(value.start_date, value.end_date);
        this.emittedDates = null;
      }
    }
  },
  methods: {
    emitDates(startDate) {
      if (this.readonly) return;
      this.emittedDates = {
        start_date: startDate,
        end_date: departureEndDate(startDate, this.numberDays)
      };
      this.$emit("input", { ...this.value, ...this.emittedDates });
    }
  }
};
</script>
